

























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {
  faChartArea,
  faChartBar,
  faChartLine,
  faChartPie,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { ChartType, DisplayOptions } from '@shared/interfaces/chart-interfaces';

library.add(faChartBar, faChartLine, faChartArea, faChartPie);
@Component({
  name: 'bc-chart-wrapper',
  components: {},
})
export default class ChartWrapper extends Vue {
  // Props
  @Prop({ type: Object }) readonly displayOptions: DisplayOptions;
  @Prop({ type: String, default: ChartType.BarChart }) readonly defaultChartType: ChartType;
  @Prop({ type: Boolean, default: false }) readonly isLoading: boolean;
  @Prop({ type: Boolean, default: false }) readonly exportActivated: boolean;
  @Prop({ type: Boolean, default: false }) readonly noResults: boolean;

  // Data
  selectedChartType: ChartType | null = null;

  // Computed
  get chartTypeEnums(): typeof ChartType {
    return ChartType;
  }

  // Lifecycle
  mounted() {
    this.selectedChartType = this.defaultChartType;
  }

  // Methods
  handleChartButtonClick(chartType: ChartType): void {
    this.selectedChartType = chartType;
    this.$emit('chart-type-change', chartType);
  }
  getButtonVariant(chartType: string): string {
    return this.selectedChartType === chartType ? 'primary' : 'light';
  }
  getButtonDisabled(chartType: string): boolean {
    return this.selectedChartType === chartType;
  }
  handleExportButtonClick(): void {
    this.$emit('export');
  }
}
